import React from 'react';

export interface CardProps {
    children: React.ReactNode;
    className?: string;
    variant?: 'white' | 'glass' | 'glass-strong' | 'outline';
    padding?: 'none' | 'sm' | 'md' | 'lg';
    hoverEffect?: boolean;
    onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
    children,
    className = '',
    variant = 'white',
    padding = 'md',
    hoverEffect = false,
    onClick
}) => {
    const baseStyles = "rounded-2xl transition-all duration-300 relative overflow-hidden";

    const variants = {
        white: "bg-white border border-gray-100 shadow-sm",
        outline: "bg-transparent border border-gray-200",
        glass: "glass-card border border-white/20",
        "glass-strong": "glass-card-strong border border-white/30"
    };

    const paddings = {
        none: "",
        sm: "p-4",
        md: "p-6",
        lg: "p-8"
    };

    const hoverStyles = hoverEffect
        ? "hover:-translate-y-1 hover:shadow-xl hover:border-[var(--color-primary-light)]/30 cursor-pointer group"
        : "";

    return (
        <div
            className={`${baseStyles} ${variants[variant]} ${paddings[padding]} ${hoverStyles} ${className}`}
            onClick={onClick}
        >
            {/* Top Gradient Line for Premium feel on white cards */}
            {hoverEffect && variant === 'white' && (
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            )}

            {children}
        </div>
    );
};
